import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BottomStrip({ hold, sim, chart, phantom, }) {
    return (_jsxs("section", { className: "bb-bottom-strip", "data-testid": "bottom-strip", style: {
            backgroundColor: "var(--color-midnight-hull)",
            color: "var(--color-pure-white)",
            borderTop: "1px solid var(--color-charcoal-deck)",
            // Pin the strip to its intrinsic height inside AppShell's flex
            // column. Without `flex-shrink: 0` the strip gets squeezed by
            // `<main>` on shorter viewports, which visually collapses the
            // ABChart legend into the right rail (the exact overlap bug).
            flex: "0 0 auto",
        }, children: [phantom && (_jsx("div", { "data-testid": "bottom-phantom", style: {
                    backgroundColor: "var(--color-pure-white)",
                    color: "var(--color-deep-ink)",
                    minHeight: 40,
                    borderBottom: "1px solid var(--color-pebble)",
                }, children: phantom })), _jsxs("div", { className: "bb-bottom-grid", style: {
                    display: "grid",
                    gap: 1,
                    gridTemplateColumns: "minmax(0, 320px) minmax(0, 380px) minmax(0, 1fr)",
                    backgroundColor: "var(--color-charcoal-deck)",
                }, children: [_jsx("div", { "data-testid": "bottom-hold", style: {
                            backgroundColor: "var(--color-midnight-hull)",
                            padding: "20px 22px",
                            minHeight: 200,
                        }, children: hold }), _jsx("div", { "data-testid": "bottom-sim", style: {
                            backgroundColor: "var(--color-midnight-hull)",
                            padding: "20px 22px",
                            minHeight: 200,
                        }, children: sim }), _jsx("div", { "data-testid": "bottom-chart", style: {
                            backgroundColor: "var(--color-midnight-hull)",
                            padding: "20px 22px",
                            minHeight: 200,
                            minWidth: 0,
                        }, children: chart })] }), _jsx("style", { children: `
        @media (max-width: 900px) {
          .bb-bottom-grid {
            grid-template-columns: minmax(0, 1fr) !important;
          }
        }
      ` })] }));
}
